import UploaderIcon from 'assets/images/uploader/uploader.svg'
import OneIcon from 'assets/images/uploader/one.svg'
import TwoIcon from 'assets/images/uploader/two.svg'
import ThreeIcon from 'assets/images/uploader/three.svg'
interface IUploadProps {
    images: IUploadImage | undefined
    setImages: React.Dispatch<React.SetStateAction<IUploadImage | undefined>>
    setImageId: React.Dispatch<React.SetStateAction<number | undefined>>
}
export default function Uploader({
    images,
    setImages,
    setImageId,
}: IUploadProps) {
    const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = e?.target
        if (files && files[0]) {
            setImages({
                file: files?.[0],
            })
            setImageId(undefined)
        }
    }
    const handleIconClick = async (id: number) => {
        setImageId(id)
        try {
            const response = await fetch(
                id === 2 ? OneIcon : id === 1 ? TwoIcon : ThreeIcon
            )
            const svgContent = await response.text()
            const blob = new Blob([svgContent], { type: 'image/svg+xml' })
            const file = new File([blob], 'one-icon.svg', {
                type: 'image/svg+xml',
            })

            setImages({
                file: file,
            })
        } catch (error) {
            console.error('Error fetching SVG:', error)
        }
    }

    return (
        <>
            <div className="extraOutline bg-white  rounded-lg mt-4 w-full flex justify-start items-center">
                <div className="file_upload relative ml-4">
                    <div className="input_field flex flex-col w-max mx-auto text-center">
                        <label>
                            <input
                                className="text-sm cursor-pointer w-36 hidden"
                                type="file"
                                multiple
                                accept=".jpg, .jpeg .png"
                                onChange={handleUpload}
                            />
                            {!images ? (
                                <div className=" rounded-full cursor-pointer">
                                    <img src={UploaderIcon} alt="uploader" />
                                </div>
                            ) : (
                                <div className=" cursor-pointer  ">
                                    <img
                                        src={URL.createObjectURL(images?.file)}
                                        alt="selected-img"
                                        className=" w-20 h-20 rounded-full p-2 border-1 border-[#DCE0E5]"
                                    />
                                </div>
                            )}
                        </label>
                    </div>
                </div>
                <div className=" border-1 border-[#747D8A] rounded-3xl p-2 mx-2">
                    <img
                        src={OneIcon}
                        alt="one"
                        className=" h-10 w-10 opacity-60"
                        onClick={() => handleIconClick(2)}
                    />
                </div>
                <div className=" border-1 border-[#747D8A] rounded-3xl p-2 mx-2">
                    <img
                        src={TwoIcon}
                        alt="one"
                        className=" h-10 w-10 opacity-60"
                        onClick={() => handleIconClick(1)}
                    />
                </div>
                <div className=" border-1 border-[#747D8A] rounded-3xl p-2 mx-2">
                    <img
                        src={ThreeIcon}
                        alt="one"
                        className=" h-10 w-10 opacity-60"
                        onClick={() => handleIconClick(3)}
                    />
                </div>
            </div>
        </>
    )
}
